import React, { FC } from 'react';
import UserPermissionGate from 'components/UserPermissionGate';
import { UserPermission } from 'constants/userPermission';
import CommentsThreads from 'app/modules/posts/modules/post/components/postCommunication/comments/CommentsThreads';
import { PostCommunicationContent } from 'app/modules/posts/modules/post/components/postCommunication/types/postCommunicationContent';
import CommentsTextEditor from 'app/modules/posts/modules/post/components/postCommunication/comments/CommentsTextEditor';

type Props = {
  type: PostCommunicationContent;
};

const Comments: FC<Props> = (props) => {
  return (
    <div className="tw-flex tw-flex-col">
      <CommentsThreads />
      {props.type !== PostCommunicationContent.PINNED && (
        <UserPermissionGate
          scopes={
            props.type === PostCommunicationContent.INTERNAL
              ? UserPermission.POST_COMMUNICATION_INTERNAL_CREATE
              : UserPermission.POST_COMMUNICATION_CLIENT_CREATE
          }
        >
          <CommentsTextEditor />
        </UserPermissionGate>
      )}
    </div>
  );
};

export default Comments;
